import socialsAiInstruction from "fragments/socialsAiInstruction"
import gql from "graphql-tag"

const GET_SOCIALS_AI_INSTRUCTIONS = gql`
  ${socialsAiInstruction}

  query getSocialsAiInstructions(
    $socialsAiInstructionsGetInput: SocialsAiInstructionsGetInput
  ) {
    getSocialsAiInstructions(
      socialsAiInstructionsGetInput: $socialsAiInstructionsGetInput
    ) {
      ...SocialsAiInstruction
    }
  }
`

export default GET_SOCIALS_AI_INSTRUCTIONS
